import axios from 'axios';
import dateFieldValue from '../objects/models/date.field.value';
import getDateStringFromObject from '../functions/get.date.string.from.object';
import the from '../objects/the';
import use from '../objects/use';
import { stripInvalidMbiChars } from '../functions/strip.invalid.mbi.chars';

export default function useFindAccountApi() {
    const tracker = use.inflightTracker!;

    const findAccount = (mbi = '', dob = dateFieldValue, lastName = '', headers: any, callBack: Function = the.emptyFunction) => {
        const url = '/account/api/verify-account';
        if (tracker.isAlreadyInflight(url))
            return;
        tracker.addApiCall(url);
        const dateOfBirth = getDateStringFromObject(dob);
        mbi = stripInvalidMbiChars(mbi);
        axios.post(
            url,
            {
                mbi,
                dateOfBirth,
                lastName
            },
            headers
        ).then(response => {
            tracker.removeApiCall(url);
            callBack({code: 200, ...response});
        }).catch(error => {
            tracker.removeApiCall(url);
            if (error.response && error.response.data) {
                callBack({code: error.response.data.code, errors: error.response.data.errors});
            } else {
                callBack();
            }
        });
    };

    return {
        findAccount,
    };
}
